import React from 'react';
import {addPrefix} from "../../../utils/UriUtil";
import {jsonResponseHandler, revenueResponseHandler} from "../../../utils/FetchHelper";
import {useDispatch, useSelector} from "react-redux";
import {setAdsenseInfo, setAdfitInfo} from "../../../actions/revenue";

const AccountInfo = ({vendor}) => {
  const dispatch = useDispatch();
  const revenue = useSelector(state => state.revenue);

  let setVendorInfo;
  if (vendor === 'adfit') {
    setVendorInfo = setAdfitInfo;
  } else if (vendor === 'adsense') {
    setVendorInfo = setAdsenseInfo;
  }
  const handleDisconnectButton = () => {
    if (confirm('연동을 해제하면 광고 설정 및 통계 확인이 불가능해집니다. 정말 해제하시겠습니까?')) {
      fetch(addPrefix(`/manage/revenue/${vendor}.json`), {
        method: 'DELETE',
        credentials: "include",
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(jsonResponseHandler(dispatch))
        .then(revenueResponseHandler(dispatch))
        .then(r => r.json())
        .then(() => {
          window.location.href = '/manage/revenue';
        })
        .catch(() => {
          alert('연동 해제 실패');
        });
    }
  };
  const reFetch = () => {
    dispatch(setVendorInfo(null));
    fetch(addPrefix(`/manage/revenue/status/${vendor}.json`), {
      method: 'GET',
      credentials: 'include'
    })
      .then(jsonResponseHandler(dispatch))
      .then(r => r.json())
      .then(data => {
        dispatch(setVendorInfo(data.data));
      })
      .catch(e => {
        console.log(e);
      });
  };

  return (
    <div className="box_blog box_revenue_type1">
      <strong className="wrap_logo">
        {vendor === 'adsense' &&
        <img src="//t1.daumcdn.net/tistory_admin/static/manage/images/temp/googleadsense.png"
             alt="Google AdSense" className="company_logo" width="140"/>
        }
        {vendor === 'adfit' &&
        <img src="//t1.daumcdn.net/tistory_admin/static/manage/images/temp/kakaoadfit.png"
             alt="kakaoAdfit" className="company_logo" width="125"/>
        }
      </strong>
      {revenue[`${vendor}Info`] && revenue[`${vendor}Info`].email !== '' &&
      <>
        <dl className="list_account">
          <dt><span className="tit_account">연동 계정</span></dt>
          <dd>
            <span className="txt_nickname">{revenue[`${vendor}Info`].email.split('@')[0]}@</span>
            <span className="txt_address">{revenue[`${vendor}Info`].email.split('@')[1]}</span>
          </dd>
        </dl>
        <a className="btn_cancel btn_cancel_type1" onClick={handleDisconnectButton}>연동 해제</a>
      </>
      }
      {revenue[`${vendor}Info`] && revenue[`${vendor}Info`].accountCode !== 'SUCCESS' &&
      <>
        <div className="statistic_refresh info_none">
          <div className="inner_refresh">
            <span className="wrap_ico"><span className="ico_blog ico_post"/></span>
            <a onClick={reFetch} className="link_none">다시 조회하기</a>
          </div>
        </div>
        <a className="btn_cancel btn_cancel_type1" onClick={handleDisconnectButton}>연동 해제</a>
      </>
      }
      {!revenue[`${vendor}Info`] &&
      <div className="date_loading">
        <div className="inner_g">
          <span className="ico_blog ico_loading">로딩중입니다.</span>
        </div>
      </div>
      }
    </div>
  )
};

export default AccountInfo;